<template>
    <modal :open="open" @close="$emit('close')" title="Delete Article Feeds">

        <h3>{{ $t('modal.bulk-delete-feeds-h3', { articleCount: deleteList.length }) }}</h3>

        <p v-t="'They will be permanently deleted. No pages will be deleted.'"></p>

        <div class="modal__done">
            <button  v-if="!saving" @click="deleteConfirm()" v-t="'Delete'"></button>
            <button  v-if="saving" v-t="'Deleting...'"></button>
            <a class="button--close" @click="$emit('close')" v-t="'Cancel'"></a>
        </div>

    </modal>
</template>

<script>
    import Modal from '@/components/Modal.vue'

    export default {
        props: ['open', 'deleteList'],
        components: {
            Modal
        },
        data () {
            return {
                saving: false,
                deletedIDs: []
            }
        },
        methods: {
            deleteRedirect (redirect) {
                this.saving = true
                var feedID = redirect.id
                this.$http.delete('/rss-feeds/'+redirect.id+'/').then( data => {
                    this.deletedIDs.push(feedID)
                    if(this.deleteList.length === 0){
                        this.saving = false;
                        this.$store.dispatch('messages/success', 'Article Feeds Deleted')
                        this.$emit('close', this.deletedIDs)
                    }else{
                        this.deleteRedirect(this.deleteList.pop());
                    }
                }).catch(errors => {
                    this.saving = null
                    this.errors = errors.response.data
                })
            },
            deleteConfirm () {
                this.saving = true
                this.deletedIDs = []
                this.deleteRedirect(this.deleteList.pop())
            }
        }
    }
</script>
